import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { FlagsStateContainer } from '@confluence/flags';

import { showNudgeFlag } from '../ui/crossJoinNudgesFlags';

import {
	fireEligibilityTracked,
	fireExperimentError,
	fireFeatureExposed,
	getExperimentAnalytics,
} from './analytics';
import { resolveCrossJoinNudges } from './resolve-cross-join-nudges';
import { isFeatureVisited, isUserOptedOut } from './feature-visited';
import { isExperimentEnabled } from './feature-flag';

const MAX_NUMBER_OF_COLLABORATORS = 5;

export interface CrossJoinNudgesInput {
	cloudId: string;
	userId: string | null;
	flags: FlagsStateContainer;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
	push: (url: string, forceReload?: boolean | undefined) => void;
}

export const triggerCrossJoinNudgeExperiment = async ({
	cloudId,
	userId,
	flags,
	createAnalyticsEvent,
	push,
}: CrossJoinNudgesInput) => {
	const analytics = getExperimentAnalytics(createAnalyticsEvent);

	try {
		if (!userId || (await isFeatureVisited('crossJoinNudgesV3'))) {
			return;
		}

		const response = await resolveCrossJoinNudges({ userId, cloudId });
		if (response.ineligibilityReason !== null) {
			fireEligibilityTracked(analytics, response.ineligibilityReason);
		} else if (response.collaborators !== null) {
			fireEligibilityTracked(analytics, 'ELIGIBLE');
			fireFeatureExposed(analytics);
			if (!isExperimentEnabled() || isUserOptedOut('crossJoinNudgesV3')) return;
			showNudgeFlag({
				userId,
				cloudId,
				collaborators: response.collaborators.slice(0, MAX_NUMBER_OF_COLLABORATORS),
				createAnalyticsEvent,
				flags,
				pushRoute: push,
			});
		}
	} catch (error: any) {
		fireExperimentError(analytics, error);
	}
};
